export enum EventEnum {
    CORE_CHANGE_LANGLUE = 'CORE_CHANGE_LANGLUE',
    NAVBAR_CHANGE_DATE = 'NAVBAR_CHANGE_DATE',
    NOTIFICATION_COMMING = 'NOTIFICATION_COMMING'
}
